import { render, staticRenderFns } from "./edit_pwd.vue?vue&type=template&id=6cb6a896&scoped=true&"
import script from "./edit_pwd.vue?vue&type=script&lang=js&"
export * from "./edit_pwd.vue?vue&type=script&lang=js&"
import style0 from "./edit_pwd.vue?vue&type=style&index=0&id=6cb6a896&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb6a896",
  null
  
)

export default component.exports